function MainController($filter, $document, $rootScope, $translate, PromotionComponent) {
	'ngInject';

	const vm = this;
	$rootScope.showBackground = true;
	vm.currentLocale = 'Български';
	vm.localeFlag = 'bg';
	vm.changeLocale = changeLocale;
	vm.showLocaleOptions = false;
	vm.test = 'test';
	vm.navItems = [
		{
			'link': 'app.public.btms.about-us',
			'name': 'ABOUT_US.LABEL'
		},
		{
			'link': 'app.public.btms.rent',
			'name': 'PAYMENT.LABEL'
		},
		{
			'link': 'app.public.btms.contacts',
			'name': 'CONTACTS.LABEL'
		},
		{
			'link': 'app.public.btms.offices',
			'name': 'OFFICE.LABEL'
		},
		{
			'link': 'app.public.login',
			'name': 'PUBLIC.AGENTS_ENTRANCE'
		}
	];
	vm.showMobileMenu = false;
	const map = angular.element(document.getElementsByClassName('homepage__container--map-image'));
	const steps = angular.element(document.getElementsByClassName('homepage__container--steps'));
	const route = angular.element(document.getElementsByClassName('homepage__image--route'));
	const bus = angular.element(document.getElementsByClassName('homepage__image--bus'));
	// IE 11 fix
	const isExplorer = navigator.userAgent.match(/Trident/g);

	// Addanimation on scroll to elements
	$document.on('scroll', function() {
		if ( window.scrollY > window.outerHeight - 750 || isExplorer ) {
			map.addClass('map-slide-in');
			steps.addClass('steps-slide-in');
		}
		
		if (window.outerWidth > 1200) {
			if ( window.scrollY > window.outerHeight - 450 || isExplorer ) {
				bus.addClass('bus-in');
				route.addClass('route-in');
				if (route.hasClass('route-in')) {
					$document.off('scroll');			
				}
			} 
		} else if ( window.scrollY > 350 || isExplorer) {
			bus.addClass('bus-in');
			route.addClass('route-in');
			$document.off('scroll');		
		}
		
	});
	
	activate();
	
	/** */
	function activate() {
		PromotionComponent.fetchPromotions()
			.then(function() {
				if (Object.keys(PromotionComponent.getPromotions()).length > 0 ) {
					const promotionValue = PromotionComponent.getPromotions()[0].value || false;

					vm.promotionValue = parseInt(promotionValue, 10);
					vm.promotionValueNew = vm.promotionValue + 10;
				}
			});
	}
	
	/** Page translations change depend on selected language
	 * @params { String } locale - selected language
	*/
	function changeLocale(locale) {
		switch (locale) {
		case 'bg':
			vm.currentLocale = 'Български';
			vm.showLocaleOptions = false;
			localStorage.setItem('lang', locale);
			vm.localeFlag = localStorage.getItem('lang');
			$translate.use(locale);
			break;
		case 'en':
			vm.currentLocale = 'English';
			vm.showLocaleOptions = false;
			localStorage.setItem('lang', locale);
			vm.localeFlag = localStorage.getItem('lang');
			$translate.use(locale);
			break;
		case 'cz':
			vm.currentLocale = 'český';
			vm.showLocaleOptions = false;
			localStorage.setItem('lang', locale);
			vm.localeFlag = localStorage.getItem('lang');
			$translate.use(locale);
			break;
		case 'hu':
			vm.currentLocale = 'Мagyar';
			vm.showLocaleOptions = false;
			localStorage.setItem('lang', locale);
			vm.localeFlag = localStorage.getItem('lang');
			$translate.use(locale);
			break;
		default:
			vm.currentLocale = 'Български';
		}
	}
}

export default MainController;



/** WEBPACK FOOTER **
 ** ./client/public/main/main.controller.js
 **/